import { sendEmailVerification } from "firebase/auth";
import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { bypassesEmailVerification } from "../utils/roleUtils";

export default function EmailVerificationGate({ children }) {
  const { currentUser, userProfile, loading } = useAuth();
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  if (loading) {
    return (
      <div className="page">
        <div className="cs-loading">Loading…</div>
      </div>
    );
  }

  if (!currentUser) return children;

  if (currentUser.emailVerified || bypassesEmailVerification(userProfile, currentUser)) {
    return children;
  }

  const handleSendVerification = async () => {
    try {
      setSending(true);
      await sendEmailVerification(currentUser);
      setSent(true);
    } catch (error) {
      console.error("Verification email error:", error);
      alert("Could not send verification email.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="page">
      <div className="studio-shell">
        <div className="studio-header">
          <p className="landing-eyebrow">Email verification</p>
          <h1>Verify your email first.</h1>
          <p className="subtitle">
            To protect creators and reduce spam, you need to verify your email before using creator tools.
          </p>
        </div>

        <div className="info-card">
          <h3>Verification required</h3>
          <p className="settings-description">
            We’ll send a verification link to {currentUser.email}. After verifying, refresh the page.
          </p>

          <button
            type="button"
            className="support-button"
            onClick={handleSendVerification}
            disabled={sending}
          >
            {sending ? "Sending..." : sent ? "Verification sent" : "Send verification email"}
          </button>
        </div>
      </div>
    </div>
  );
}
